import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { PopoverController } from '@ionic/angular';
import { FilterService } from '../../_services/filter.service';
import { ListDisplayService } from '../list-display/list-display.service';

@Component({
  selector: 'app-filters-modal',
  templateUrl: './app-filters-modal.component.html'
})
export class AppFiltersModalComponent implements OnInit {
  ios = false;
  @Input() itemList:any;
  @Input() itemFilters:any;
  @Input() options:any;
  @Input() tableConfig:any;

  filtersSelected = false;

  constructor(
    private filterService: FilterService,
    private modalCtrl: PopoverController,
    private listDisplayService: ListDisplayService,
  ) { }

  ngOnInit() {
  }

  dismiss(data?: any) {
    this.modalCtrl.dismiss(data);
  }

  resetFilters() {
    this.filterService.resetFilters(this.itemList, this.itemFilters);
    this.filtersSelected = false;
    this.options.onFiltersReset();
  }

  filtersApplied(data) {
    this.listDisplayService.filtersApplied(this.tableConfig);
  }

  distributorInfoClicked(distInfo) {
    if (this.options && this.options.onDistributorInfoClicked) {
      this.options.onDistributorInfoClicked(distInfo);
    }
  }

}
